import { lazy } from 'react'

export const StayOutVariant1 = lazy(() => import('./StayOutVariant1'))
